import type { ClientManagementRow } from '../components/crm/client-management/types';

const tierLabel = (tier: ClientManagementRow['loyaltyTier']): string => {
  const map: Record<ClientManagementRow['loyaltyTier'], string> = {
    BRONZE: 'Bronce',
    SILVER: 'Plata',
    GOLD: 'Oro',
    PLATINUM: 'Platino',
  };
  return map[tier];
};

const escapeCsv = (value: string | number | null | undefined): string => {
  const s = value == null ? '' : String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

/** Descarga CSV UTF-8 con BOM para Excel (columnas alineadas a la tabla CRM). */
export function downloadClientsCsv(rows: ClientManagementRow[], filename = 'clientes.csv'): void {
  const headers = [
    'Nombre',
    'CI',
    'Correo',
    'Teléfono',
    'Nº referencia 1',
    'Nº referencia 2',
    'Nivel de lealtad',
    'Total compras',
    'Nº compras',
    'Marketing',
  ];
  const lines = [
    headers.join(','),
    ...rows.map((r) =>
      [
        escapeCsv(r.customerName),
        escapeCsv(r.identityDocumentNumber),
        escapeCsv(r.customerEmail),
        escapeCsv(r.customerPhone),
        escapeCsv(r.referenceNumber1),
        escapeCsv(r.referenceNumber2),
        escapeCsv(tierLabel(r.loyaltyTier)),
        escapeCsv(r.totalPurchases),
        escapeCsv(r.purchaseCount),
        escapeCsv(r.marketingConsent ? 'Sí' : 'No'),
      ].join(','),
    ),
  ];
  const blob = new Blob(['\ufeff', lines.join('\n')], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
